<form [formGroup]="formServiciosBucket" class="flow-form">

  <!-- ==========================================================================
       01. INFORMACIÓN DEL FLUJO
       ========================================================================== -->

  <div class="flow-section">

    <div class="flow-section-header">

      <div class="flow-section-icon">
        <i class="fa-solid fa-diagram-project"></i>
      </div>

      <div class="flow-section-title">

        <h5>
          Información del flujo
        </h5>

        <p>
          Define la información general y el endpoint asociado al flujo.
        </p>

      </div>

    </div>


    <!-- ==========================================================================
         02. CAMPOS
         ========================================================================== -->

    <div class="row g-3">

      <!-- ========================================================================
           NOMBRE
           ======================================================================== -->

      <div class="col-lg-6 col-md-6 col-12">

        <div class="flow-field">

          <label class="form-label">
            Nombre
            <span class="required">*</span>
          </label>

          <div class="flow-input">

            <span class="flow-input-icon">
              <i class="fa-solid fa-signature"></i>
            </span>

            <input type="text" class="form-control" placeholder="Ej: Firma externa" formControlName="nombre">

          </div>


          <span class="flow-error" *ngIf="
              formServiciosBucket.get('nombre')?.touched &&
              formServiciosBucket.get('nombre')?.errors?.['required']
            ">

            <i class="fa-solid fa-circle-exclamation"></i>

            El nombre es requerido.

          </span>

        </div>

      </div>


      <!-- ========================================================================
           DESCRIPCIÓN
           ======================================================================== -->

      <div class="col-lg-6 col-md-6 col-12">

        <div class="flow-field">

          <label class="form-label">
            Descripción
            <span class="required">*</span>
          </label>

          <div class="flow-input">

            <span class="flow-input-icon">
              <i class="fa-solid fa-align-left"></i>
            </span>

            <input type="text" class="form-control" placeholder="Ej: Flujo para firma externa de documentos"
              formControlName="descripcion">

          </div>


          <span class="flow-error" *ngIf="
              formServiciosBucket.get('descripcion')?.touched &&
              formServiciosBucket.get('descripcion')?.errors?.['required']
            ">

            <i class="fa-solid fa-circle-exclamation"></i>

            La descripción es requerida.

          </span>

        </div>

      </div>


      <!-- ========================================================================
           ENDPOINT
           ======================================================================== -->

      <div class="col-lg-6 col-md-6 col-12">

        <div class="flow-field">

          <label class="form-label">
            Endpoint
            <span class="required">*</span>
          </label>

          <div class="flow-input">

            <span class="flow-input-icon">
              <i class="fa-solid fa-link"></i>
            </span>

            <input type="text" class="form-control" placeholder="Ej: sobres/externos" formControlName="endpoint">

          </div>


          <span class="flow-field-help">

            Ruta utilizada para ejecutar este flujo.

          </span>


          <span class="flow-error" *ngIf="
              formServiciosBucket.get('endpoint')?.touched &&
              formServiciosBucket.get('endpoint')?.errors?.['required']
            ">

            <i class="fa-solid fa-circle-exclamation"></i>

            El endpoint es requerido.

          </span>

        </div>

      </div>


      <!-- ========================================================================
           PREDETERMINADO
           ======================================================================== -->

      <div class="col-lg-6 col-md-6 col-12">

        <div class="default-flow-option">

          <div class="default-flow-content">

            <div class="default-flow-icon">
              <i class="fa-solid fa-star"></i>
            </div>


            <div class="default-flow-text">

              <strong>
                Flujo predeterminado
              </strong>

              <span>
                Utilizar este flujo como opción principal del servicio.
              </span>

            </div>

          </div>


          <label class="flow-switch mb-0">

            <input id="es_predeterminado" type="checkbox" formControlName="es_predeterminado">

            <span class="flow-switch-slider"></span>

          </label>

        </div>

      </div>

    </div>

    <div class="row g-3">
      <div class="col-lg-6 col-md-6 col-12">

        <div class="default-flow-option">

          <div class="default-flow-content">

            <div class="default-flow-icon">
              <i class="fa-solid  fa-file-zipper"></i>
            </div>


            <div class="default-flow-text">

              <strong>
                Plantilla pre-calibrada
              </strong>

              <span>
                Utilizar para definir si la plantilla de este flujo ya esta pre-calibrada.
              </span>

            </div>

          </div>


          <label class="flow-switch mb-0">

            <input id="plantilla_precalibrada" type="checkbox" formControlName="plantilla_precalibrada">

            <span class="flow-switch-slider"></span>

          </label>

        </div>

      </div>
    </div>

  </div>


  <!-- ==========================================================================
       03. AYUDA
       ========================================================================== -->

  <div class="flow-help">

    <div class="flow-help-icon">
      <i class="fa-solid fa-circle-info"></i>
    </div>

    <div>

      <strong>
        Configuración del flujo
      </strong>

      <span>
        Verifica que el endpoint corresponda al flujo que deseas ejecutar
        antes de guardar la configuración.
      </span>

    </div>

  </div>


  <!-- ==========================================================================
       04. ACCIONES
       ========================================================================== -->

  <div class="flow-form-actions">

    <div class="flow-required-info">

      <i class="fa-solid fa-circle-info"></i>

      <span>
        Los campos marcados con * son obligatorios.
      </span>

    </div>


    <div class="flow-action-buttons">

      <button type="button" class="flow-btn-close" (click)="CloseModal()">

        Cerrar

      </button>


      <button type="button" class="flow-btn-save" (click)="guardarServicioBucket()" [disabled]="
          formServiciosBucketIsSubmited ||
          formServiciosBucket.invalid
        ">

        <span class="spinner-border spinner-border-sm" *ngIf="formServiciosBucketIsSubmited">
        </span>

        <i class="fa-solid fa-floppy-disk" *ngIf="!formServiciosBucketIsSubmited">
        </i>

        <span>
          Guardar
        </span>

      </button>

    </div>

  </div>

</form>